import axios from "axios";
import { data } from "jquery";
import API from "../_helpers/endpointService";
import moment from 'moment';

export const addprojectbasicinfo = (data, formData) => {
  let apiUrl = API.ADDEDIT_PROJECT;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          localStorage.setItem("addeditid", response.data)
          dispatch(addprojectlogoinfo(formData, response.data))
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const addprojectinchargeinfo = (data, access) => {
  let apiUrl = API.ADDEDITINCHARGE_PROJECT;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
      headers: {
        'key': access
      }
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const putprojectinchargeinfo = (data, access) => {
  let apiUrl = API.ADDEDITINCHARGE_PROJECT;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
      headers: {
        'key': access
      }
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const addprojectshipinfo = (data) => {
  let apiUrl = API.ADDEDIT_SHIPINFO;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const addprojectlogoinfo = (formData, id) => {
  let apiUrl = API.ADDEDIT_PROJECT + id;
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      data: formData,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {

        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const addprojectprocessinfo = (data) => {
  let apiUrl = API.ADDPROCESSINFO_PROJECT;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "post",
      url: apiUrl,
      data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const getprojectbasicinfo = (data) => {
 
    let apiUrl = API.ADDEDIT_PROJECT + data;
   
    return (dispatch) => {
      axios({
        method: "get",
        url: apiUrl,
        data: data,
      })
        .then((response) => {
          if (response?.status === 200) {
              localStorage.setItem("ProjectName", response.data?.ProjectName)
              let date = (response?.data?.ExtensionDate != "0001-01-01T00:00:00" && moment(response?.data?.ExtensionDate).format("yyyy-MM-DD") != "0001-00-01" && moment(response?.data?.ExtensionDate).format("yyyy-MM-DD") != "0001-01-01" && moment(response?.data?.ExtensionDate).format("yyyy") != "0001") ? response?.data?.ExtensionDate : null;
              let data = response?.data;
              data.ExtensionDate = date;
              localStorage.setItem("BasicInfo", JSON.stringify(data))
            dispatch({ type: "GETBASICINFO_PROJECT", data: response.data });
          } else {
          }
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            dispatch({ type: "SHOW_LOADER", data: false })
            // logOut();
          }
        });
    };
  
};

export const putprojectintroinfo = (data, id) => {
  let apiUrl = API.ADDEDIT_PROJECT + id;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "put",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {

        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};
export const putprojectbasicinfo = (data, id, formData) => {
  let apiUrl = API.ADDEDIT_PROJECT + id;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "put",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch(addprojectlogoinfo(formData, id))
        } else {
          dispatch({ type: "SHOW_LOADER", data: false })
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const filedeleteprojectlogo = (id, name) => {
  let apiUrl = API.ADDEDIT_PROJECT + 'logo/' + id + '?uniquefilename=' + name;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "delete",
      url: apiUrl,
      // data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {

        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const filedeleteprojectownerlogo = (id, name) => {
  let apiUrl = API.ADDEDIT_PROJECT + 'ownerlogo/' + id + '?uniquefilename=' + name;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "delete",
      url: apiUrl,
      // data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {

        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {

          // logOut();
        }
      });
  };
};

export const filedeleteprojectheaderlogo = (id, name) => {
  let apiUrl = API.ADDEDIT_PROJECT + 'headerlogo/' + id + '?uniquefilename=' + name;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "delete",
      url: apiUrl,
      // data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {

        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {

          // logOut();
        }
      });
  };
};

export const getprojectshipinfo = (data) => {
  let apiUrl = API.GETSHIPINFO_PROJECT + data + "/shipParticular";
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "get",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "GETSHIPINFO_PROJECT", data: response.data });
        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const putprojectshipinfo = (data, id) => {
  let apiUrl = API.ADDEDIT_SHIPINFO + id;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "put",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {

        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {

          // logOut();
        }
      });
  };
};

export const getprojectprocessinfo = (data) => {
  let apiUrl = API.ADDEDIT_PROJECT + data + '/ProcessOrder';
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
      data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "GETPROCESSINFO_PROJECT", data: response.data });

        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {

          // logOut();
        }
      });
  };
};

export const deleteproject = (data) => {
  let apiUrl = API.ADDEDIT_PROJECT + data;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "delete",
      url: apiUrl,
      data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {

        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {

          // logOut();
        }
      });
  };
};

export const getSettingsDateFormat = () => {
  let apiUrl = API.SETTINGS_PROJECT + 'TimeFormat';
  return (dispatch) => {
    // dispatch({type:"SHOW_LOADER",data:true})
    axios({
      method: "GET",
      url: apiUrl,
      // data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        // dispatch({type:"SHOW_LOADER",data:false})
        if (response?.status === 200) {
          dispatch({ type: "FORMAT_VALUES", data: response.data });

        } else {

        }
      })
      .catch((error) => {
        // dispatch({type:"SHOW_LOADER",data:false})
        if (error?.response?.status === 401) {

          // logOut();
        }
      });
  };
  //   var tempData = [
  //     {
  //         Id: 1,
  //         Convertion: "yyyy-MM-dd"
  //     },
  //     {
  //         Id: 3,
  //         Convertion: " MMM dd yy"
  //     },
  //     {
  //       Id: 4,
  //       Convertion: " yyyy MMM dd "
  //   },
  // ];
  // return (dispatch) => {
  //   dispatch({ type: "FORMAT_VALUES", data: tempData });
  // };
};

export const postSettingsDateFormat = (data) => {
  let apiUrl = API.SETTINGS_PROJECT_POST;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          // dispatch(postSettingsTimeszones(data1))
          // dispatch({ type: "FORMAT_VALUES", data: response.data });
        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {

          // logOut();
        }
      });
  };
  //   var tempData = [
  //     {
  //         Id: 1,
  //         Convertion: "yyyy-MM-dd"
  //     },
  //     {
  //         Id: 3,
  //         Convertion: " MMM dd yy"
  //     },
  //     {
  //       Id: 4,
  //       Convertion: " yyyy MMM dd "
  //   },
  // ];
  // return (dispatch) => {
  //   dispatch({ type: "FORMAT_VALUES", data: tempData });
  // };
};

export const getSettingsTimeszones = () => {
  let apiUrl = API.SETTINGS_PROJECT + "TimeZone";
  return (dispatch) => {
    // dispatch({type:"SHOW_LOADER",data:true})
    axios({
      method: "GET",
      url: apiUrl,
      // data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        // dispatch({type:"SHOW_LOADER",data:false})
        if (response?.status === 200) {
          dispatch({ type: "TIME_VALUES", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        // dispatch({type:"SHOW_LOADER",data:false})
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };

  //   var tempData = [
  //     {
  //       Id: 1,
  //       TimeZoneName: "(GMT+02=00) Harare,Pretoria	"

  //   },
  //   {
  //       Id: 3,
  //       TimeZoneName: "(GMT-06=20) Central America		"
  //   }, 
  //   {
  //     Id: 3,
  //     TimeZoneName: "(GMT+02=00) Greenland	"
  // },   
  // ];
  // return (dispatch) => {
  //   dispatch({ type: "TIME_VALUES", data: data });
  // };
};

export const postSettingsTimeszones = (data) => {
  let apiUrl = API.SETTINGS_PROJECT + "TimeZone?timeZoneId=" + data.timeZoneId + "&projectId=" + data.ProjectId;
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      // data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          // dispatch({ type: "TIME_VALUES", data: response.data });
        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const gethistorylogprojectdocinfo = (id) => {
  let apiUrl = API.HISTORY_LOG + id + '?name=Project'
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
      // data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "HISTORY_LOG", data: response.data });

        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};
